import { LoaderMode, LoaderTheme, LoaderV2 } from "components/common/LoaderV2/LoaderV2";
import React from "react";

export const AgGridLoaderOverlay = () => {
  return (
    <div className="w-full h-full flex items-center justify-center p-6">
      <LoaderV2 mode={LoaderMode.inline} theme={LoaderTheme.brand} size="sm" />
    </div>
  );
};
